import { CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { SharedService } from '@app/_services/shared.service';
import * as _ from 'lodash';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../shared/directives/click.directive';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-block-stores-new',
    templateUrl: './block-stores-new.component.html',
    styleUrls: ['./block-stores-new.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, MatIconModule, CarouselModule, OwlPreventClickDirective, NgFor, ClickDirective, RouterLink]
})
export class BlockStoresNewComponent implements OnInit, AfterViewInit {
    sector;
    @Input() companies;
    @Input() name = {
        en: "Stores",
        ar: "المتاجر"
    };
    @Input() loop = false;
    load = false;
    image = 'assets/images/nologo.png';
    layout: 'grid-4' | 'grid-4-sm' | 'grid-5' | 'horizontal' | 'custom' = 'custom';
    carouselDefaultOptions: any = {
        lazyLoad:true,
        items: 6,
        margin: 14,
        nav: false,
        dots: false,
        loop: this.loop || false,
        skip_validateItems : true,
        stagePadding: 1,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout: any = {
        'grid-4': {
            responsive: {
                1110: { items: 6, margin: 0 },
                930: { items: 6, margin: 0 },
                690: { items: 6, margin: 0 },
                400: { items: 6, margin: 0 },
                0: { items: 2.5, margin: 0 }
            }
        },
        'grid-4-sm': {
            responsive: {
                820: { items: 4, margin: 0 },
                640: { items: 3, margin: 0 },
                400: { items: 2, margin: 0 },
                0: { items: 2, margin: 0 }
            }
        },
        'grid-5': {
            responsive: {
                1110: { items: 5, margin: 0 },
                930: { items: 4, margin: 0 },
                690: { items: 3, margin: 0 },
                400: { items: 2, margin: 0 },
                0: { items: 2, margin: 0 }
            }
        },
        'custom': {
            responsive: {
                1210: { items: 8, margin: 0 },
                910: { items: 8, margin: 0 },
                730: { items: 6, margin: 0 },
                590: { items: 5, margin: 0 },
                400: { items: 3, margin: 0 },
                0: { items: 2, margin: 0 }
            }
        },
        horizontal: {
            items: 3,
            responsive: {
                1110: { items: 3, margin: 0 },
                930: { items: 3, margin: 0 },
                690: { items: 2, margin: 0 },
                0: { items: 2, margin: 0 }
            }
        }
    };

    constructor(
        private shareService: SharedService,
        public translationHelper: TranslateHelper,
        public direction: DirectionService,
        private cdr: ChangeDetectorRef
    ) {
        this.sector = this.shareService.page;
    }

    @ViewChild('carousel', { static: false}) carousel : CarouselComponent


    ngAfterViewInit(): void {
        //this.carouselDefaultOptions.loop = this.loop;
        this.carouselDefaultOptions = { ...this.carouselDefaultOptions, loop: this.loop }
        this.load = true;

    }


    carouselOptions;
    ngOnInit(): void {
        this.carouselOptions = Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);
    }

     
    imagebObjectKey(imageObject) {
        return _.findKey(imageObject);
    }
}
